import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import React, { useState, useEffect, useTransition } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
} from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter  } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/user.jpg"
// actions
import { getProfile, editProfile, closeAccount, resetProfileFlag } from "../../store/actions"
import { post, del, get, put } from "helpers/api_helper"

const UserProfile = props => {

  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [fullName, setFullName] = useState("")
  const [userId, setUserId] = useState("")
  const [role, setRole] = useState('');
  const [PhoneNumber, setPhoneNumber] = useState("")
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {    
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (obj.uid) loadData(obj.uid);
  }, [])
  useEffect(() => {
    if (props?.success) {
      if(enabled) {
        setName(props.success.data.userName);
        setFullName(props.success.data.fullName);
        setEmail(props.success.data.email);
        setUserId(props.success.data.id);
        setRole(props.success.data.role);
        setPhoneNumber(props.success.data.phoneNumber || '');

        setTimeout(() => {
          props.resetProfileFlag();
        }, 3000);
      } else {
        localStorage.clear();
        sessionStorage.clear();
        props.history.push('/logout');
      }      
    }
  }, [props.success])

  const loadData = async (userID) => {
    props.getProfile(userID);
  }

  const handleValidSubmit = (event, values) => {
    values.role = role;
    values.id = userId;
    values.enabled = true;
    props.editProfile(values);
  }

  const gotoChangePassword = () => {
    props.history.push('/resetpass');
  }

  const closeAccount = () => {
    setEnabled(false);
    props.closeAccount({});
  }

  useEffect(() => {  
    setTimeout(() => {
      props.resetProfileFlag();
    }, 3000);
  }, [props.error])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profile | FlyingCarpet Marketer Admin Dashboard</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumb title="Veltrix" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {props.error && props.error ? (
                <Alert color="danger">{`error : ${props.error}`}</Alert>
              ) : null}
              {props.success? (
                <Alert color="success">{props.success.message}</Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="align-self-center flex-1 ms-3">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id : {userId}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">User profile</h4>

          <Card>
            <CardBody>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                <div className="mb-3">
                  <AvField
                    name="userName"
                    label="User Name"
                    value={name || ''}
                    className="form-control"
                    placeholder="Enter User Name"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="fullName"
                    label="User Full Name"
                    value={fullName || ''}
                    className="form-control"
                    placeholder="Enter User Full Name"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="email"
                    label="User Email"
                    value={email || ''}
                    className="form-control"
                    placeholder="Enter Email"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-3 d-none">
                  <AvField
                    name="role"
                    label="User Role"
                    value={role || ''}
                    className="form-control"
                    placeholder="Enter Role"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="phoneNumber"
                    label="phone Number"
                    type="tel"
                    value={PhoneNumber}
                    validate={{
                      // required: { value: true, errorMessage: 'Phone number is required' },
                      phone: { value: true, errorMessage: 'Invalid phone number' }
                    }}
                    placeholder="Enter phone number"
                  />
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="success" className='mx-1'>
                    Update User profile
                  </Button>
                  <Button color="success" className="mx-1" onClick={gotoChangePassword}>
                    Change Password
                  </Button>
                  <Button color="danger" className="mx-1" onClick={closeAccount}>
                    Close Account
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}


const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { getProfile, editProfile, closeAccount, resetProfileFlag })(UserProfile)
)
